(ns dashboard.views.login.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::login
 (fn [db]
   (:login db)))

(rf/reg-sub
 ::login-form
 :<- [::login]
 (fn [login]
   (let [type (get login :form-type :login)]
     {:type type
      :values (get-in login [:form type])})))

(rf/reg-sub
 ::login-form-state
 :<- [::login]
 (fn [login [_ type]]
   (get-in login [:form type])))
